import newRelicApi from "./newrelic";
import mosaicApi from "./mosaic";

export const noticeError = newRelicApi.noticeError;

export const noticeInteraction = (id, params = {}) => {
  // eslint-disable-next-line no-console
  console.log(`noticeInteraction: ${id} ${JSON.stringify(params)}`);

  if (typeof params !== "object") {
    throw Error("extra params must be type object");
  }
  newRelicApi.noticeInteraction(id, params);
  mosaicApi.noticeInteraction(id, params);
};

export const setAttribute = (key, value) => {
  newRelicApi.setAttribute(key, value);
  mosaicApi.setAttribute(key, value);
};

export const unsetAttribute = (key) => {
  newRelicApi.unsetAttribute(key);
  mosaicApi.unsetAttribute(key);
};
